import { CContainer, CForm } from "@coreui/react";
import { FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";
import { Steps, useSteps } from "react-step-builder";
import { Loading, Progress, ProgressBar } from "src/components";
import { selectOrgId } from "src/store/projectSelectors";
import { Completed, Step } from "../components";
import { useEsgSurveyQuestions, useUserEsgSurvey } from "../hooks";
import SummaryEsgContent from "./SummaryEsgContent";

const UserEsgSurvey = () => {
  const respondentId = useSelector(selectOrgId);

  const { currentSurvey } = useEsgSurveyQuestions({
    orgId: respondentId,
    isStandalone: true,
  });
  const surveyAreas = currentSurvey?.areas || [];

  const {
    status,
    data,
    onChange,
    formMethods,
    nextClickHandler,
    prevClickHandler,
  } = useUserEsgSurvey({
    respondentId,
    surveyAreas,
  });

  const {
    formState: { errors },
    // watch,
  } = formMethods;

  // const track = watch("track") || "validation";

  const values = data || {};
  const stepAttr = { values, onChange, errors, respondentId };
  const { current, total } = useSteps();

  const highestCompleted = +values?.["highest-completed"] || 0;

  const progressStyle = {
    zIndex: 999,
    position: "absolute",
  };

  const SurveySteps = [];

  SurveySteps.push(
    ...(surveyAreas?.map((step) => {
      return <Step key={step.key} {...stepAttr} area={step} />;
    }) || [])
  );

  const navigationSteps = [
    "Environment",
    "Community",
    "Employees",
    "Governance",
    "Conclusion",
    "Summary",
  ].slice(0, highestCompleted + 1);

  return (
    <FormProvider
      {...{
        ...formMethods,
        nextClickHandler,
        prevClickHandler,
        showBackButton: false,
        hideStepComplete: true,
        isSurvey: true,
        navigationSteps,
      }}
    >
      <CForm className="w-100" onSubmit={nextClickHandler}>
        {status === "success" && !!surveyAreas?.length && (
          <Progress style={progressStyle}>
            <ProgressBar value={(current / total) * 100} />
          </Progress>
        )}
        {status !== "success" || !surveyAreas?.length ? (
          <Loading />
        ) : (
          <Steps>
            {SurveySteps}
            <Completed {...stepAttr} />
            <CContainer>
              <SummaryEsgContent orgId={respondentId} isStep />
            </CContainer>
          </Steps>
        )}
      </CForm>
    </FormProvider>
  );
};

export default UserEsgSurvey;
